import React, { useEffect, useState } from "react";
import { Alert, Box, Typography } from "@mui/material";
import { InlineText } from "../InlineText";

import { ReactComponent as LightningIcon } from "../../assets/svgs/lightning.svg";
import { ReactComponent as ThumbUpIcon } from "../../assets/svgs/thumb-up.svg";
import { ReactComponent as LockIcon } from "../../assets/svgs/lock.svg";
import { ReactComponent as ShieldIcon } from "../../assets/svgs/shield.svg";
import { PlaidLink } from "../PlaidLink";
import { useAuth } from "../../hooks/useAuth";

import "./style.css";

const IdentityVerification = (props) => {
    const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();

    const [status, setStatus] = useState("");
    const [loadingDetails, setLoadingDetails] = useState(false);

    const handleIDVEvent = (event) => {
        if (event.detail.type === "success") {
            setStatus("Success");
            const updateUserDetails = new CustomEvent("updateUserDetails", {
                detail: { type: "Success" },
            });
            document.dispatchEvent(updateUserDetails);
            handleChange(true);
            setLoadingDetails(false);
            setTimeout(() => {
                document.querySelector("#next-btn").click();
            }, 3000);
        } else if (event.detail.type === "In Progress") {
            setLoadingDetails(true);
        } else {
            setStatus("Failed");
            handleChange(false);
            setLoadingDetails(false);
            props.onFailed();
        }
    };

    const handleChange = (value) => {
        props.onChange(value);
    };

    useEffect(() => {
        document.addEventListener("plaidIDVEvent", handleIDVEvent);
        return () => {
            document.removeEventListener("plaidIDVEvent", handleIDVEvent);
        };
    }, []);

    return (
        <Box
            className="IdentityVerification"
            sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}
        >
            {status === "Failed" && (
                <Alert sx={{ mb: "2rem" }} severity="error">
                    Identity verification has failed. You can still continue, however, you will be required to verify your identity with our team before you are approved.
                </Alert>
            )}
            {status === "Success" && (
                <Alert sx={{ mb: "2rem" }} severity="success">
                    Successfully verified your identity.
                </Alert>
            )}
            <Typography variant="h1" component="h1">
                Let's verify your identity first!
            </Typography>
            <Typography variant="h6" component="h6" sx={{ textAlign: "center" }}>
                We will verify your identity and pre fill your personal details from the Plaid.
            </Typography>
            <Box sx={{ my: "2rem", width: "80%" }}>
                <PlaidLink></PlaidLink>
            </Box>

            <Box fullWidth sx={{ width: "80%" }}>
                <Typography variant="h6" component="h6">
                    We verify your identity to help protect you from fraud and use the information to run a credit and
                    background check.
                </Typography>

                <Typography sx={{ mt: "15px" }} variant="h6" component="h6">
                    <b>Step 1:</b> Take a photo of your government-issued ID (ie Driver’s License or Passport)
                </Typography>
                <Typography sx={{ mt: "5px" }} variant="h6" component="h6">
                    <b>Step 2:</b> Take a selfie. Don’t worry about how you look. This is only used match the photo on
                    your ID.
                </Typography>
            </Box>
        </Box>
    );
};

export { IdentityVerification };
